export default "__VITE_ASSET__BhQUk2gd__"